import { reactive } from "vue";

// Reactive toast list singleton
const toasts = reactive([]);

let nextId = 1;

function addToast(message, type = "info", options = {}) {
  const id = nextId++;
  const duration = options.duration || 3500;
  const toast = {
    id,
    message: String(message || ""),
    type,
    duration,
  };
  toasts.push(toast);
  // Auto-remove after duration
  setTimeout(() => removeToast(id), duration);
  return id;
}

function removeToast(id) {
  const index = toasts.findIndex((t) => t.id === id);
  if (index !== -1) toasts.splice(index, 1);
}

export const toast = {
  success(message, options) {
    return addToast(message, "success", options);
  },
  error(message, options) {
    return addToast(message, "error", options);
  },
  info(message, options) {
    return addToast(message, "info", options);
  },
  warning(message, options) {
    return addToast(message, "warning", options);
  },
  remove: removeToast,
};

export { toasts };


